module.exports = __webpack_public_path__ + "img/ic_signal.d11f90bf.svg";